export default __webpack_public_path__ + "static/media/upload-dialog-error.aafea317.svg";